import { render, staticRenderFns } from "./ActivitySession.vue?vue&type=template&id=4a8c0566&"
import script from "./ActivitySession.vue?vue&type=script&lang=js&"
export * from "./ActivitySession.vue?vue&type=script&lang=js&"
import style0 from "./ActivitySession.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports